import React from "react";
import Layout from "../../components/layout/Layout/Layout";
import Header from "../../components/layout/Header/Header";
import { Tickets } from "../../components/layout/Ticket/Tickets";
import { GetServerSideProps } from "next";
import { createTicketPurchase } from "../../lib/ticketsRequests";
import * as Sentry from "@sentry/nextjs";

export default function TicketsPage() {
  return (
    <Layout>
      <Header></Header>
      <Tickets />
    </Layout>
  );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
  const { req, query } = context;
  const asPath = req.url || '';
  const sessionId = query?.session_id;
  const cookies = req.headers.cookie;

  try {
    if (asPath.includes("sale/completed")) {
      const { data } = await createTicketPurchase(sessionId as string, cookies);
      return {
        redirect: {
          destination: data.url,
          permanent: false,
        },
      };
    }
    return {
      props: {},
    };

  } catch (err) {
    Sentry.captureException(err);
    return {
      redirect: {
        destination: `/tickets/${query.slug[0]}?error=${err.data?.error}`,
        permanent: false,
      },
    
    };
  }
};
